module.exports = __webpack_public_path__ + "img/gc_country_flag_py.2f4ade50.svg";